import SalarieNom from '@/generated/controls/salarie/SalarieNom.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SalarieNom
})
